module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAA9UlEQVQoFZWRMU4CURCGCVBAxyHkDgRtLWml8A4UFhRyAIy1CSUx8RJewMQETbShkIqWhMoApd+XzbwFwq5hki9v9s38b2ZnKpXc6rhD+IINrOEVrqHQLoh8wBwGcAU9GMMvTKAGB2YlRc/QOIhkH22OHxgdx2zPSqdEkdvF2YKPJPvGs73/7I2E+0iq4vh/n3FRcpqTKircQatEECFzVvGhcAaXcVFwmtcBV5XMPTny1EaK5M4d7hKa+VXmuSdH7vT2zUqK/J2H/UD47tI9OXKn9wQvsAArKVJ8AyfNdh35FB7hFqK9Pr5iz7MtxIWVy15U/P4HS1grHBKAYNgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/grp-search-icon.png
// module id = 305
// module chunks = 33